// Sentry disabled - self-hosted deployment
// This file configures the initialization of Sentry on the client.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
// import * as Sentry from "@sentry/nextjs";
import { initBotId } from "botid/client/core";
import process from "node:process";

// if (process.env.NODE_ENV === "production") {
//   Sentry.init({
//     dsn: process.env.NEXT_PUBLIC_SENTRY_DSN_CLIENT,
//     sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE ?? "1.0") || 1.0,
//     tracesSampleRate: parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE ?? "0.0") || 0.0,
//     debug: !!process.env.SENTRY_DEBUG,
//     beforeSend(event) {
//       if (
//         event.exception?.values?.some(
//           (e) =>
//             e.value?.includes("Non-Error promise rejection captured with") ||
//             e.value?.includes("Object Not Found Matching Id")
//         )
//       ) {
//         return null;
//       }
//       event.tags = { ...event.tags, errorSource: "client" };
//       return event;
//     },
//   });
// }

export function onRouterTransitionStart(
  _url: string,
  _navigationType: "push" | "replace" | "traverse"
) {
  // Sentry disabled - self-hosted
  // if (process.env.NODE_ENV === "production") {
  //   Sentry.captureRouterTransitionStart(url, navigationType);
  // }
}

if (
  process.env.NEXT_PUBLIC_VERCEL_USE_BOTID_IN_BOOKER === "1" &&
  typeof window !== "undefined" &&
  typeof window.crypto?.getRandomValues === "function" &&
  typeof window.crypto?.randomUUID === "function"
) {
  initBotId({
    protect: [
      {
        path: "*/api/book/event",
        method: "POST",
      },
    ],
  });
}
